import type { IconSvgObject } from './types';

const AlignHorizontalSpaceAroundIcon: IconSvgObject = [
  ["path", { d: "M19 2V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 2V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9.5 8.5L9.5 15.497C9.5 16.326 10.1724 16.9978 11.0014 16.997L13.0014 16.9952C13.8293 16.9944 14.5 16.323 14.5 15.4952L14.5 8.5C14.5 7.67157 13.8284 7 13 7H11C10.1716 7 9.5 7.67157 9.5 8.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default AlignHorizontalSpaceAroundIcon;
